export class ListEffectivePoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<DataCatalogAccessPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListEffectivePoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
